import React, { useState, useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"

import "./../index.css"

import SellerPOView from "../../SellerPO/Components/SellerPOView"

import { getSellerPOBySellerPOId } from "../../../services/api/sellerPO"
import { raiseToast } from "../../../services/redux/reducers/toast/toast"
import { fetchApprovals } from "../../../services/redux/reducers/commonThunk"

import { searchMaterialMandatoryUseFromStock } from "../../../services/api/materialMandatoryUseFromStock"
import { getCompanyCertificates } from "../../../services/api/companyCertificates"


const NewSellerPOModalData = (props) => {
    const { sellerPOId, materialDetails, buyerQuoteItems, buyerPOItems, sellerReqs, sellerReqItems, sellerCompanyDetails, sellerPOItems, selectedReq } = props

    const dispatch = useDispatch()

    const [sellerPO, setSellerPO] = useState(props.sellerPO)
    const [sellerPIPunch, setSellerPIPunch] = useState([])
    const [sellerPIPunchItems, setSellerPIPunchItems] = useState([])
    const [sellerGRNQCPunch, setSellerGRNQCPunch] = useState([])
    const [companyCertificates, setCompanyCertificates] = useState([])
    const [sellerReq, setSellerReq] = useState(props.sellerReq)

    const [pmCompanyBillAddrDetails, setPMCompanyBillAddrDetails] = useState({})
    const [sellerBillAddrDetails, setSellerBillAddrDetails] = useState({})
    const [documentHTML, setDocumentHTML] = useState('')
    const [sellerPOPdfURL, setSellerPOPdfURL] = useState('')
    const [approvalInstances, setApprovalInstances] = useState(props.approvalInstances)
    const [nonRoutedSellerPOsInfo, setNonRoutedSellerPOsInfo] = useState([])
    const [materialMandatoryUseFromStock, setMaterialMandatoryUseFromStock] = useState([])

    const [sellerShipAddrDetails, setSellerShipAddrDetails] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        dispatch(fetchApprovals())
    }, [])

    useEffect(() => {
        if (sellerPOId){
            getSellerPO()
        }
    }, [sellerPOId])

    const getSellerPO = async () => {
        setIsLoading(true)

        const response = await getSellerPOBySellerPOId(sellerPOId, true)
        if (response.failure){
            dispatch(raiseToast({severity:'error', detail: response.data.error, summary:'Seller PO is Not Fetched.', life: 3000}))
        }
        else {
            const newSellerPO = response?.data.sellerPO
            const newSellerPOItems = response.data.sellerPOItems
            const newSellerPIPunch = response?.data.sellerPIPunch
            const newSellerPIPunchItems = response?.data.sellerPIPunchItems
            const newSellerGRNQCPunch = response?.data.sellerGRNQCPunch

            let materialIds = newSellerPOItems.map(eachSellerPOItem => eachSellerPOItem.materialId)

            const materialMandatoryUseFromStockRes = await searchMaterialMandatoryUseFromStock({materialIds, paginator: false})
            console.log("materialMandatoryUseFromStockRes", materialMandatoryUseFromStockRes)
            if(materialMandatoryUseFromStockRes.failure){
                return dispatch(raiseToast({severity:'error', summary:'Mandatory material use from stock',  detail: materialMandatoryUseFromStockRes.data.error, life: 3000}))
            }

            setMaterialMandatoryUseFromStock(materialMandatoryUseFromStockRes.data.data)

            const companyIds = sellerReqs.map(eachSellerReq => eachSellerReq.companyId)
            const brandIds = materialDetails.map(eachMaterial => eachMaterial.brandId)
            const companyCertificatesRes = await getCompanyCertificates({companyIds: companyIds, entityIds: brandIds, entityType: 'Brand'})

            if (companyCertificatesRes.failure){
                return dispatch(raiseToast({ severity: 'error', summary: "Company Certificates", details: companyCertificatesRes.data.error, life: 3000 }))
            }

            setCompanyCertificates(companyCertificatesRes.data.data)

            setSellerPO(newSellerPO)
            setSellerPIPunch(newSellerPIPunch)
            setSellerPIPunchItems(newSellerPIPunchItems)
            setSellerGRNQCPunch(newSellerGRNQCPunch)

            setPMCompanyBillAddrDetails(response?.data?.pmCompanyBillAddrDetails)
            setSellerBillAddrDetails(response?.data?.sellerBillAddrDetails)
            setSellerPOPdfURL(response?.data?.sellerPOPdfURL)
            setDocumentHTML(response?.data?.documentHTML)
            setSellerShipAddrDetails(response?.data?.sellerShipAddrDetails)
            setNonRoutedSellerPOsInfo(response.data.nonRoutedSellerPOsInfo)

            setIsLoading(false)
        }
    }

    const relatedNonRoutedSellerPOsInfo = nonRoutedSellerPOsInfo.find(eachNonRoutedSellerPO => eachNonRoutedSellerPO.companyId === sellerPO.companyId && eachNonRoutedSellerPO.docNo === sellerPO.docNo)

    return (
        <>
            { sellerPO.sellerPOId && sellerCompanyDetails ?
                <SellerPOView
                    displayTable={true} 
                    sellerPOId={sellerPOId}
                    sellerPO={sellerPO}
                    sellerPOItems={sellerPOItems}
                    sellerReqs={sellerReqs}
                    sellerReqItems={sellerReqItems}
                    sellerPIPunch={sellerPIPunch}
                    sellerPIPunchItems={sellerPIPunchItems}
                    sellerReq={sellerReq}
                    buyerQuoteItems={buyerQuoteItems}
                    buyerPOItems={buyerPOItems}
                    materialDetails={materialDetails}
                    sellerCompanyDetails={sellerCompanyDetails}
                    pmCompanyBillAddrDetails={pmCompanyBillAddrDetails}
                    sellerBillAddrDetails={sellerBillAddrDetails}
                    sellerShipAddrDetails={sellerShipAddrDetails}
                    documentHTML={documentHTML}
                    setSellerPO={setSellerPO}
                    getSellerPO={getSellerPO}
                    setDocumentHTML={setDocumentHTML}
                    sellerPOPdfURL={sellerPOPdfURL}
                    setSellerPOPdfURL={setSellerPOPdfURL}
                    approvalInstances={approvalInstances}
                    setApprovalInstances={setApprovalInstances}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    selectedReq={selectedReq}
                    nonRoutedSellerPOsInfo={relatedNonRoutedSellerPOsInfo}
                    buyerReq={selectedReq}
                    materialMandatoryUseFromStock={materialMandatoryUseFromStock}
                    companyCertificates={companyCertificates}
                /> : null 
            }
        </>
    )
}

export default NewSellerPOModalData;